const MAC = 'Mac'
// Office.js PlatformType for Windows desktop (window.Office.context.platform)
const PC = 'PC'
// Office.js PlatformType for PowerPoint on the web — note it is NOT 'Web'.
const OFFICE_ONLINE = 'OfficeOnline'

export default {
  MAC,
  PC,
  OFFICE_ONLINE,
}
